import { Icon } from "@components";
import { AddProductInBasketType, Basket } from "@utilities/types";
import { FC, useMemo } from "react";
import { BasketComponent } from "./BasketComponent";

interface Props {
    basket: Basket | null;
    isCartOpen: boolean;
    totalSavings?: number;
    toggleCart: () => void;
    onStacheBasket: () => void;
    onAddProductInBasket: (basketElement: Partial<AddProductInBasketType>) => void
    onRemoveProductInBasket: (basketElement: AddProductInBasketType, isRemoveFullElement?: boolean) => void
}

export const BasketButtonComponent: FC<Props> = ({
    basket,
    isCartOpen,
    totalSavings = 0,
    toggleCart,
    onStacheBasket,
    onAddProductInBasket,
    onRemoveProductInBasket,
}) => {

    const basketItems = useMemo(() => basket?.basket || [], [basket]);

    return (
        <div
            className="fixed bottom-[15%] lg:bottom-16 right-4 z-20"
        >
            <div className="relative inline-block">
                <button
                    onClick={toggleCart}
                    className="btn btn-primary flex items-center space-x-2 rounded-full shadow-lg cursor-pointer"
                >
                    <Icon iconName="ShoppingBasket" />
                </button>

                {
                    !!basketItems.length && <span
                        className="absolute -top-2 -left-2 badge badge-accent 
                        gap-2 text-xs font-bold rounded-full 
                        h-6 w-6 flex items-center justify-center"
                    >
                        {basketItems.length}
                    </span>
                }
            </div>

            {
                isCartOpen && (
                    <div
                        className="absolute bottom-14 sm:bottom-16 right-0 bg-white rounded-lg w-[18rem] sm:w-full md:w-[420px] p-3 sm:p-4 shadow-lg border-t-4 border-primary"
                    >
                        <div
                            className="flex justify-between items-center mb-3 sm:mb-4"
                        >
                            <h2 className="text-base sm:text-lg font-semibold">Mon Panier</h2>

                            <button
                                onClick={toggleCart}
                                className="text-secondary cursor-pointer"
                            >
                                <Icon iconName="CircleX" size={30} />
                            </button>
                        </div>

                        <BasketComponent
                            basket={basket}
                            totalSavings={totalSavings}
                            onAddProductInBasket={onAddProductInBasket}
                            onRemoveProductInBasket={onRemoveProductInBasket}
                            onStacheBasket={onStacheBasket}
                        />
                    </div>
                )
            }
        </div>
    )
}
